// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i4b1","name":"styles_name__35Tlr","phone":"styles_phone__1NXXb"};